import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=8bd23478&scoped=true&"
import script from "./ArticlePage.vue?vue&type=script&lang=js&"
export * from "./ArticlePage.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePage.vue?vue&type=style&index=0&id=8bd23478&lang=scss&scoped=true&"
import style1 from "./ArticlePage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd23478",
  null
  
)

export default component.exports